<template>
  <div class="modal fade" :id="modalId" tabindex="-1" role="dialog"  aria-hidden="true">
    <div v-if="show !== false" class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header" style="padding: 20px 15px; ">
          <div class="text-right"><a class="closebox" data-dismiss="modal" aria-hidden="true"><i class="fa fa-times"></i></a></div>
          <h4 class="modal-title" style="font-weight: 600;">
            <template v-if="file">
              Protect {{ file.name }}
            </template>
            <template v-else>
              Protect a new file
            </template>
          </h4>
          <span class="font-bold">
              Generate a Proof of Existence of your work recorded in the blockchain
            </span>
        </div>
        <form v-on:submit="save" class="form-horizontal" action="#" method="post" id="timestamp_file_form" >
          <div class="modal-body">

            <div class="form-group" v-if="isManuallyAdded === true">
              <label for="title" class="col-xs-3 control-label required">File to protect</label>
              <div class="col-xs-9 m-b-xs m-t text-center">
                <label class="btn btn-primary btn-outline btn-sm file-uploads file-uploads-html5"><i class="fa fa-plus"></i>
                  Choose a file
                  <input type="file" name="file" style="display: none"  @change="onChangeFile($event)">
                </label>
                <span style="margin-left: 50px" v-if="uploadFile">{{ uploadFile.name }}</span>
                <div>
                  <span v-if="errorFiles" class="text-danger">{{ errorFiles }}</span>
                </div>
              </div>
            </div>

            <div class="form-group m-t-lg" v-if="isManuallyAdded">
              <label for="cp_project" class="col-xs-3 control-label required">Project</label>
              <div class="col-xs-9">
                <v-select2 id="cp_project" :options="projects" label="name" v-model="projectSelected"
                           :searchable="true" :dropdownParent="modalId" :placeholder="'Select a project'"></v-select2>
                <label v-if="errorProject" class="error">{{ errorProject }}</label>
              </div>
            </div>

            <div class="form-group m-t-lg">
              <label for="title" class="col-xs-3 control-label required">Title</label>
              <div class="col-sm-9">
                <input id="title" v-model="title" class="form-control" required
                       :class="{'has-error' : errorTitle, 'has-success' : errorTitle === false}">
                <span v-if="errorTitle" class="text-danger">{{ errorTitle }}</span>
              </div>
            </div>

            <div class="form-group m-t-lg">
              <label for="description" class="col-xs-3 control-label">Description</label>
              <div class="col-xs-9">
                      <textarea v-model="description"  id="description" class="form-control"
                                :disabled="disable"  maxlength="1500" placeholder="1500 characters max" rows="4" cols="3"
                                :class="{'has-error' : errorDescription, 'has-success' : errorDescription === false}" ></textarea>
                <span class="help-block m-b-none text-right" v-if="description">{{description.length}} Characters</span>
                <span v-if="errorDescription" class="text-danger">{{ errorDescription }}</span>
              </div>
            </div>

            <div class="form-group m-t-lg" v-if="isManuallyAdded">
              <label for="type" class="col-xs-3 control-label required">Type</label>
              <div class="col-xs-9">
                <v-select2 id="type" :options="timestampedTypes" label="name" v-model="timestampedTypeSelected" :placeholder="'select a type'"></v-select2>

                <span v-if="errorType" class="text-danger">{{ errorType }}</span>
              </div>
            </div>

            <div class="form-group m-t-lg">
              <label class="col-xs-3 control-label required">Co-Owner(s)
                <i class="fa fa-info-circle text-info" data-toggle="popover" :data-content="'Enter the authors in the same order as in the publication'" style="cursor: pointer;"></i>
              </label>
              <div class="col-xs-9">
                <div v-for="(owner, key) in owners" v-bind:key="key">
                  <Owners :owner="owner" :removeAuthor="removeAuthor" :index="key"/>
                </div>
                <div class="text-center" style="margin-top: 10px" >
                  <button class="btn btn-xs btn-outline btn-primary" v-on:click="addAuthor" ><i class="fa fa-plus"></i> Add Co-Owner</button>
                </div>
                <span v-if="errorOwners" class="text-danger">{{ errorOwners }}</span>
              </div>
            </div>
            <!--              <div class="form-group m-t-lg">-->
            <!--                <label class="col-xs-3 control-label text-left ">Project Tags-->
            <!--                  <i class="fa fa-info-circle text-info" data-toggle="popover" :data-content="'Enter specialities and product categories. Each tag no longer than 35 characters.'" style="cursor: pointer;"></i>-->
            <!--                </label>-->
            <!--                <div class="col-xs-9">-->
            <!--                  <keywords ref="projectTags" v-model="tags"-->
            <!--                            :placeholder="'Enter keywords and project tags'" :itemClassName="'projectTags'" :disabled="disable"></keywords>-->
            <!--                </div>-->
            <!--              </div>-->

          </div>
          <div class="modal-footer">
            <div class="row">
              <div class="col-xs-6 text-center">
                <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>
              </div>
              <div class="col-xs-6 text-center">
                <vue-ladda  type="submit" :loading="submit.loading" class="btn btn-info" :data-style="submit.dataStyle" @click="save"> Protect File</vue-ladda>
              </div>
            </div>
          </div>
        </form>

      </div>
    </div>
  </div>

</template>
<style >
#timestamp_file_form .v-select input[type=search], #company_info_form .v-select input[type=search]:focus {
  border: none;
}
#timestamp_file_form .bootstrap-tagsinput {
  border: 1px solid #ccc !important;
}
</style>
<script>
import VSelect2 from '../utils/select2'
import VueLadda from 'vue-ladda'
import Keywords from '../../components/user/KeywordBox'
import Owners from './Owners'

export default {
  components: {
    VueLadda,
    VSelect2,
    Keywords,
    Owners
  },
  name: 'ActionModalTimestamp',
  watch: {
    projectSelected: function (project) {
      if (project !== null) {
        this.initOwner()
        this.setTitle(project.name)
        this.setDescription(project.description)
      }
    }
  },
  data () {
    return {
      file: null,
      modalId: null,
      show: false,
      timestampedTypes: [],
      projects: [],
      projectSelected: null,
      timestampedTypeSelected: null,
      owners: [],
      description: null,
      title: null,
      isManuallyAdded: true,
      uploadFile: null,
      tags: null,
      disable: false,
      errorOwners: null,
      errorTitle: null,
      errorDescription: null,
      errorType: null,
      errorProject: null,
      errorFiles: null,
      submit: {
        loading: false,
        'dataStyle': 'zoom-in'
      },
      submitAction: 'post'
    }
  },
  methods: {
    afterUpload: function () {
      let dataTimestamp = {
        title: this.title,
        description: this.description,
        owners: this.owners,
        tags: this.tags ? this.tags.replace(/,/g, ';') : null,
        is_manually_added: this.isManuallyAdded
      }
      if (this.submitAction === 'post') {
        dataTimestamp.file_id = this.file === null ? null : this.file.id
        dataTimestamp.type_id = this.timestampedTypeSelected !== null ? this.timestampedTypeSelected.id : null

        this.axios.post('/timestamped', dataTimestamp).then((response) => {
          this.timestamped = response.data

          this.$notify({
            type: 'success',
            title: 'File was submitted for protection',
            placement: 'bottom-right'
          })

          $('#' + this.modalId).modal('hide')
        }).catch((error) => {
          let errors = error.response.data.errors

          if (typeof errors['title'] !== 'undefined') {
            this.errorTitle = errors['title'][0]
          }
          if (typeof errors['description'] !== 'undefined') {
            this.errorDescription = errors['description'][0]
          }
          if (typeof errors['filename'] !== 'undefined') {
            this.errorFiles = errors['filename'][0]
          }
          if (typeof errors['data_hash'] !== 'undefined') {
            this.errorFiles = errors['data_hash'][0]
          }
          if (typeof errors['type_id'] !== 'undefined') {
            this.errorType = errors['type_id'][0]
          }
          if (typeof errors['project_id'] !== 'undefined') {
            this.errorCountry = errors['project_id'][0]
          }
          if (typeof errors['website'] !== 'undefined') {
            this.errorWebsite = errors['website'][0]
          }
        }).finally(() => {
          this.submit.loading = false
        })
      } else {
        this.$emit('dataTimestamp', dataTimestamp)
        $('#' + this.modalId).modal('hide')
        this.submit.loading = false
      }
    },
    save: async function (event) {
      event.preventDefault()
      this.submit.loading = true

      this.errorTitle = null
      this.errorDescription = null
      this.errorProject = null
      this.errorType = null
      this.errorFiles = null

      if (this.isManuallyAdded === true) {
        if (this.uploadFile === null) {
          this.errorFiles = 'You must choose a file'
        }
        if (this.timestampedTypeSelected === null) {
          this.errorType = 'You must select a type for you file'
        }
        if (this.projectSelected === null) {
          this.errorProject = 'You must select a project'
        }
      }
      if (this.title === null) {
        this.errorTitle = 'Title can\'t be empty'
      }
      if (this.owners.length === 0) {
        this.errorOwners = 'You must fill owners'
      }
      if (this.errorFiles === null && this.errorType === null && this.errorTitle === null && this.errorOwners === null &&
        this.errorProject === null) {
        if (this.file === null && this.submitAction === 'post') {
          this.upload().then((response) => {
            this.afterUpload()
          })
        } else {
          this.afterUpload()
        }
      } else {
        this.submit.loading = false
      }
    },
    getResources: function () {
      if (this.isManuallyAdded === true) {
        this.getProjects()
        this.getTimestampedTypes()
      }
    },
    onChangeFile: function (event) {
      this.uploadFile = event.target.files[0]
    },
    upload: function () {
      return new Promise((resolve, reject) => {
        if (this.uploadFile) {
          let data = new FormData()
          data.append('file', this.uploadFile)
          data.append('target', 'personnel_file')
          data.append('project_id', this.projectSelected ? this.projectSelected.id : null)

          this.axios.post('/timestamped/upload/', data).then((response) => {
            this.file = response.data
            resolve(response)
          }).catch((error) => {
            if (typeof error.response !== 'undefined') {
              if (error.response.status === 413) {
                this.$notify({
                  type: 'danger',
                  title: 'An error has occurred, max upload size is 10 Mo',
                  placement: 'bottom-right'
                })
              } else {
                let errors = error.response.data.errors
                switch (error.response.data.code) {
                  case 1:
                    this.errorFiles = errors['files'][0]
                    break
                }
              }
            }
            reject(error)
          })
        } else {
          this.errorFiles = 'Please Select a file'
          resolve(null)
        }
      })
    },
    addAuthor: function (event) {
      event.preventDefault()
      this.owners.push({
        first_name: null,
        last_name: null,
        organisation_name: null
      })
    },
    removeAuthor: function (event, index) {
      event.preventDefault()
      this.owners.splice(index, 1)
    },
    getTimestampedTypes: function () {
      this.axios.get('/timestamped/types')
        .then((response) => {
          this.timestampedTypes = response.data
        })
        .catch((error) => {
        })
    },
    getProjects: function () {
      this.axios.get('/project/own?relations={owner}')
        .then((response) => {
          this.projects = response.data

          this.projects.sort((project1, project2) => {
            let name1 = project1.name.toLowerCase()
            let name2 = project2.name.toLowerCase()
            if (name1 < name2) { return -1 }
            if (name1 > name2) { return 1 }
            return 0
          })
        })
        .catch((error) => {
        })
    },
    fillForm: function (file) {
      if (file !== null && typeof file !== 'undefined') {
        this.file = file

        if (typeof file.project !== 'undefined') {
          this.projectSelected = file.project
          this.title = file.project.name
          this.description = file.project.name
        }
        this.isManuallyAdded = false
      } else {
        this.isManuallyAdded = true
        this.file = null
        this.projectSelected = null
        this.title = null
        this.description = null
        this.timestampedTypeSelected = null
        this.tags = null
        this.initOwner()
      }
    },
    setTitle: function (title) {
      this.title = title
    },
    setDescription: function (description) {
      this.description = description
      if (this.description) {
        this.description = this.description.replace(/(<\/p>)/gi, '\n')
        this.description = this.description.replace(/(<([^>]+)>)/gi, '')
      }
    },
    setIsManuallyAdded: function (isManuallyAdded) {
      this.isManuallyAdded = isManuallyAdded
    },
    setSubmitAction (action = null) {
      this.submitAction = action
    },
    setProjectSelected: function (project) {
      this.projectSelected = project
    },
    openSupport: function () {
      let iframe = document.getElementById('launcher')
      let supportButton = iframe.contentWindow.document.querySelector('#Embed button')

      if (typeof supportButton !== 'undefined') {
        supportButton.click()
      }
    },
    openModal: function () {
      this.show = true

      setTimeout(() => {
        $('#' + this.modalId).modal('show')
      }, 200)

      $('#' + this.modalId).on('hide.bs.modal', () => {
        this.clearAll()
      })
    },
    initOwner: function () {
      this.owners = []

      let user = this.$auth.user()
      if (this.projectSelected !== null && typeof this.projectSelected.owner !== 'undefined' && user.id !== this.projectSelected.owner.id) {
        this.owners.push({
          first_name: this.projectSelected.owner.firstname,
          last_name: this.projectSelected.owner.lastname,
          organisation_name: this.projectSelected.owner.company_name
        })
      }

      this.owners.push({
        first_name: user.firstName,
        last_name: user.lastName,
        organisation_name: user.company
      })
    },
    clearAll: function () {
      this.show = false
      this.title = null
      this.description = null
      this.description = null
      this.owners = []
      this.timestampedTypeSelected = null
      this.projectSelected = null
      this.uploadFile = null
      this.file = null
      this.tags = null
    }
  },
  mounted () {
    $('[data-toggle="popover"]').popover({
      trigger: 'click hover',
      placement: 'top',
      container: 'body',
      html: true
    })
  },
  beforeMount () {
    this.modalId = '_' + Math.random().toString(36).substr(2, 9)
    this.getResources()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Timestamp/ActionModalTimestamp.vue